export function Default() {
  return <svg viewBox="0 0 1 1" />;
}
